// extracted by mini-css-extract-plugin
export default {"container":"BI-z","error":"CI-z","disabled":"DI-z","submit":"EI-z","option":"FI-z","success":"GI-z","failure":"HI-z"};